import { Box, Heading, Text, TextArea } from 'native-base'
import { FormikProps } from 'formik'

import { colors } from '../../utils/theme/configureTheme'
import ExperienceRatingSmiley from '../ExperienceRatingSmiley'
import OptionChips from './OptionChips'
import { FeedbackFormValues, SUPPORT_ISSUE_OPTIONS } from './types'

interface SupportExperienceSectionProps {
  formikProps: FormikProps<FeedbackFormValues>
}

/** Feedback form section for rating customer support experience and capturing issue reasons. */
export default function SupportExperienceSection({ formikProps }: SupportExperienceSectionProps) {
  const { values, setFieldValue } = formikProps

  return (
    <Box px={4} pb={4}>
      <Heading fontSize={18} fontWeight="600" fontFamily="bodySemiBold" color={colors.brand.vermillion} mb={3}>
        Support Experience
      </Heading>
      <Box backgroundColor={colors.brand.white} borderRadius={12} p={4} borderWidth={1} borderColor={colors.gray[200]}>
        <ExperienceRatingSmiley
          header="How was your experience interacting with our support team?"
          onSmileyPress={rating => {
            setFieldValue('supportExperience', rating)
            if (rating > 2) {
              setFieldValue('supportIssueReasons', [])
            }
          }}
          existingRating={values.supportExperience ?? undefined}
        />
        {values.supportExperience !== null && values.supportExperience <= 2 && (
          <OptionChips
            options={SUPPORT_ISSUE_OPTIONS}
            selected={values.supportIssueReasons}
            onChange={reasons => setFieldValue('supportIssueReasons', reasons)}
            columns={2}
          />
        )}
        {values.supportExperience !== null && (
          <Box mt={2}>
            <Text fontSize={14} fontWeight="500" fontFamily="Matter Regular" mb={2}>
              Any additional information you want to provide?
            </Text>
            {/* @ts-expect-error missing tvParallaxProperties, onTextInput */}
            <TextArea
              value={values.additionalSupportComments}
              onChangeText={text => setFieldValue('additionalSupportComments', text)}
              placeholder="Tell us more about your support experience..."
              autoCompleteType={undefined}
              h={100}
              borderWidth={2}
              borderColor={colors.brand.softBlack}
              borderRadius={8}
              fontSize={14}
              fontFamily="Matter Regular"
              p={3}
            />
          </Box>
        )}
      </Box>
    </Box>
  )
}
